import { playSound } from '@/utils/sound';
import React, { useEffect, useRef, useState } from 'react';
import styles from './style.less';

export const LongTouchAction = ({
  children,
  className = '',
  actions,
}: {
  children: React.ReactNode;
  className?: string;
  actions?: React.ReactNode;
}) => {
  const [showAction, setShowAction] = useState<boolean | null>(null);

  const timerRef = useRef<number | undefined>(undefined);
  const startPointRef = useRef<{ x: number; y: number }>();

  const clear = () => {
    if (timerRef.current !== undefined) {
      clearTimeout(timerRef.current);
      timerRef.current = undefined;
    }
  };

  const start = (e: React.PointerEvent) => {
    // 只处理主指针
    if (!e.isPrimary) {
      return;
    }

    clear();

    startPointRef.current = {
      x: e.clientX,
      y: e.clientY,
    };

    timerRef.current = window.setTimeout(() => {
      if (actions) {
        setShowAction(true);
      }

      timerRef.current = undefined;
    }, 500);
  };

  const move = (e: React.PointerEvent) => {
    if (!startPointRef.current) {
      return;
    }

    const dx = e.clientX - startPointRef.current.x;
    const dy = e.clientY - startPointRef.current.y;

    // 移动超过 8px，认为用户是在滑动，而不是长按
    if (Math.hypot(dx, dy) > 8) {
      clear();
      startPointRef.current = undefined;
    }
  };

  const end = () => {
    clear();
    startPointRef.current = undefined;
  };

  useEffect(() => {
    if (showAction !== null) {
      playSound('flip');
    }
  }, [showAction]);

  useEffect(() => {
    return clear;
  }, []);

  return (
    <div
      className={`${className} ${styles.wrapper}`}
      onPointerDown={start}
      onPointerMove={move}
      onPointerUp={end}
      onPointerCancel={end}
      onPointerLeave={end}>
      {children}

      {showAction && (
        <div
          className={styles.mask}
          onClick={() => {
            setShowAction(false);
          }}>
          {actions}
        </div>
      )}
    </div>
  );
};
